module.exports = __webpack_public_path__ + "media/images/about/time/1-a7323aa2c320ea8384248ee7bd06f20c.png";